<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serviceManagement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('serviceManagement.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card class="">
      <ts-card-wrapper>
        <div style="min-height: 80vh;">
          <div class="row">
            <div class="col-md-4">
              <h1 class="ts-uppercase ts-text-base ts-text-yellow-700">
                <span><i class="fas fa-user-edit"></i></span>
                {{ $t('serviceManagement.mySummary') }}
              </h1>
              <br />
              <div
                class="ts-pl-4 ts-pr-6 ts-py-4 ts-w-full ts-border ts-border-dashed ts-rounded ts-space-y-4"
              >
                <div @click.prevent="() => (view_type = 0)">
                  <SummaryCardList
                    :title="$t('serviceManagement.progressingRequest')"
                    bgBadgeColor="ts-bg-green-500"
                    bgSelected="#caebd7"
                    :numberTask="progressings.length"
                    :selected="view_type == 0 ? true : false"
                  />
                </div>
                <div @click.prevent="() => (view_type = 1)">
                  <SummaryCardList
                    :title="$t('serviceManagement.plannedMaintenance')"
                    bgBadgeColor="ts-bg-blue-500"
                    bgSelected="#c8e1f5"
                    :numberTask="plannedMaintenances.length"
                    :selected="view_type == 1 ? true : false"
                  />
                </div>
                <div @click.prevent="() => (view_type = 2)">
                  <SummaryCardList
                    :title="$t('serviceManagement.pendingRequest')"
                    bgSelected="#f9efcc"
                    bgBadgeColor="ts-bg-yellow-500"
                    :numberTask="pendings.length"
                    :selected="view_type == 2 ? true : false"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="ts-flex ts-justify-between ts-items-center">
                <h1 class="ts-uppercase ts-text-base ts-text-blue-500">
                  <span><i class="fas fa-file-signature"></i></span>
                  {{ $t('serviceManagement.myRequest') }} :
                  {{ filterViewType.length }}
                </h1>
                <div class="ts-space-x-3">
                  <button
                    @click.prevent="addNew()"
                    style="padding: 5px 18px;"
                    class="ts-bg-blue-600 ts-rounded-md ts-text-white"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                  <button
                    @click.prevent="goServiceRequestList"
                    style="padding: 5px 18px;"
                    class="ts-bg-gray-400 ts-rounded-md ts-text-black"
                  >
                    {{ $t('serviceManagement.showAll') }}
                  </button>
                </div>
              </div>
              <br />
              <div
                class="ts-p-4 ts-w-full ts-border ts-border-dashed ts-rounded ts-space-y-2 ts-overflow-y-scroll"
                style="max-height: 700px;"
              >
                <div
                  class="ts-flex ts-justify-between ts-border-b ts-border-dashed row-task hover:ts-bg-gray-200 ts-px-4 ts-py-1"
                  v-for="(row, index) in filterViewType"
                  :key="index"
                >
                  <div>
                    <h4
                      class="ts-text-lg ts-tracking-wide ts-text-blue-700 hover:ts-underline ts-cursor-pointer"
                      @click.prevent="onViewServiceRequest(row)"
                    >
                      {{ row.service_request_no }}
                    </h4>
                    <p class="ts-mb-1">
                      <b>Service Request Type : </b>
                      <span class="badge bg-primary tw-capitalize px-2"
                        >{{
                          row.service_request_type
                            ? row.service_request_type.service_request_type
                            : ''
                        }}
                      </span>
                    </p>
                    <p class="ts-mb-0">
                      <b>Fee Type : </b>
                      <span class="badge bg-success tw-capitalize px-2"
                        >{{ row.fee_type ? row.fee_type.product_name_en : '' }}
                      </span>
                    </p>
                  </div>
                  <div class="ts-relative">
                    <div
                      class="ts-flex ts-space-x-3 ts-text-yellow-700 "
                      v-if="row.service_request_date"
                    >
                      <p class="ts-w-full ts-text-right ts-font-bold">
                        {{ row.service_request_date }}
                      </p>
                    </div>
                    <a-select
                      v-model="row.service_status"
                      class="ts-w-full"
                      size="small"
                      placeholder="Select"
                      :loading="row._deleting"
                      :disabled="row._deleting"
                      @change="onChangeServiceStatus(row)"
                    >
                      <a-select-option
                        v-for="item in serviceStatus"
                        :key="item.value"
                        :value="item.value"
                        class="ts-items-center"
                      >
                        <a-icon
                          type="tag"
                          theme="filled"
                          :style="'color:' + item.color + ';'"
                        />
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <a-modal
        v-if="showModal"
        v-model="showModal"
        :title="$t('serviceRequest.pageTitle')"
        :footer="null"
        :centered="true"
        :maskClosable="false"
        :zIndex="1000"
        width="50%"
        @cancel="onCancel"
      >
        <Form @cancel="onCancel" />
      </a-modal>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SummaryCardList from './components/summary-card-list.vue'
import Form from './form.vue'

export default {
  components: {
    SummaryCardList,
    Form
  },
  data() {
    return {
      loading: false,
      showModal: false,
      totalTask: 0,
      view_type: 0,
      service_requests: []
    }
  },
  created() {
    this.fetchServiceRequest()
  },
  computed: {
    filterViewType() {
      switch (this.view_type) {
        case 0:
          return this.progressings
        case 1:
          return this.plannedMaintenances
        case 2:
          return this.pendings

        default:
          return []
      }
    },
    progressings() {
      return this.service_requests.filter(el => el.service_status == 1)
    },
    pendings() {
      return this.service_requests.filter(el => el.service_status == 0)
    },
    plannedMaintenances() {
      return this.service_requests.filter(el => el.service_request_type_id == 1)
    },
    serviceStatus() {
      return [
        {
          label: 'Pending',
          value: 0,
          color: '#6c757d'
        },
        {
          label: 'Progressing',
          value: 1,
          color: '#17a2b8'
        },
        {
          label: 'Completed',
          value: 2,
          color: '#28a745'
        },
        {
          label: 'Cancel',
          value: 3,
          color: '#dc3545'
        }
      ]
    }
  },
  methods: {
    ...mapActions('serviceManagement/home', ['getServiceRequest']),
    addNew() {
      this.$router.push({ name: 'service-request-create' })
    },
    onCancel() {
      this.showModal = false
      this.fetchServiceRequest()
    },
    fetchServiceRequest() {
      this.loading = true
      this.getServiceRequest()
        .then(response => {
          this.service_requests = response.data
        })
        .finally(() => (this.loading = false))
    },
    goServiceRequestList() {
      this.$router.push({ name: 'service-request' })
    },
    onChangeServiceStatus(record) {
      record._deleting = true
      this.$store
        .dispatch('serviceManagement/serviceRequest/changeServiceStatus', {
          id: record.service_request_id,
          data: { service_status: record.service_status }
        })
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetchData()
        })
        .finally(() => (record._deleting = false))
    },
    onViewServiceRequest(record) {
      this.$router.push({
        name: 'service-request-view',
        params: {
          id: record.service_request_id
        }
      })
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
.close-btn {
  display: none !important;
}
.row-task:hover .close-btn {
  display: block !important;
}
.anticon {
  vertical-align: 0;
}
</style>
